export const STUDENT_SIDEBAR_OVERLAY_MAX_WIDTH = 1024;

/**
 * Tablet and mobile viewports hide the in-flow student sidebar behind the hamburger.
 * @param {number} width
 * @returns {boolean}
 */
export function isStudentSidebarOverlayViewport(width) {
  return Number.isFinite(width) && width <= STUDENT_SIDEBAR_OVERLAY_MAX_WIDTH;
}
